// eslint-disable-next-line import/no-cycle
import { TemplateParentTypeEnum } from '@/types';
// V3
// eslint-disable-next-line import/no-cycle
import * as email from '@/components/template-builder/config/templates/email/raw-html-config';
// eslint-disable-next-line import/no-cycle
import * as popup from '@/components/template-builder/config/templates/popup/raw-html-config';
// eslint-disable-next-line import/no-cycle
import * as embed from '@/components/template-builder/config/templates/embed/raw-html-config';
// eslint-disable-next-line import/no-cycle
import * as facebookMessenger from '@/components/template-builder/config/templates/facebookmessenger/raw-html-config';
// eslint-disable-next-line import/no-cycle
import * as teaser from '@/components/template-builder/config/templates/teaser/raw-html-config';
// V4
// eslint-disable-next-line import/no-cycle
import * as emailV4 from '@/components/template-builder/config/templates/email-v4/raw-html-config';
// eslint-disable-next-line import/no-cycle
import * as popupV4 from '@/components/template-builder/config/templates/popup-v4/raw-html-config';
// eslint-disable-next-line import/no-cycle
import * as embedV4 from '@/components/template-builder/config/templates/embed-v4/raw-html-config';

interface RawHtmlMap {
  [key: string]: () => string;
}

interface RawWidgetStructureMap {
  [key: string]: RawHtmlMap;
}

interface RawColumnsLayoutWidgetStructureMap {
  [key: string]: Function;
}

// structures
export const RAW_COLUMN_STRUCTURE_MAP: RawHtmlMap = {
  [TemplateParentTypeEnum.EMAIL]: email.rawColumn,
  [TemplateParentTypeEnum.POPUP]: popup.rawColumn,
  [TemplateParentTypeEnum.EMBED]: embed.rawColumn,
  [TemplateParentTypeEnum.TEASER]: teaser.rawColumn,
};

export const RAW_LINE_STRUCTURE_MAP: RawHtmlMap = {
  [TemplateParentTypeEnum.EMAIL]: email.rawLine,
  [TemplateParentTypeEnum.POPUP]: popup.rawLine,
  [TemplateParentTypeEnum.EMBED]: embed.rawLine,
  [TemplateParentTypeEnum.TEASER]: teaser.rawLine,
};

export const RAW_SECTION_STRUCTURE_MAP: RawHtmlMap = {
  [TemplateParentTypeEnum.EMAIL]: email.rawSection,
};

export const RAW_PLACEHOLDER_STRUCTURE_MAP: RawHtmlMap = {
  [TemplateParentTypeEnum.EMAIL]: email.rawWidgetPlaceholder,
  [TemplateParentTypeEnum.POPUP]: popup.rawWidgetPlaceholder,
  [TemplateParentTypeEnum.EMBED]: embed.rawWidgetPlaceholder,
  [TemplateParentTypeEnum.TEASER]: teaser.rawWidgetPlaceholder,
};

export const getWidgetStructures = (t: Function, additionalConfiguration: Record<string, any>, isV4 = false): RawWidgetStructureMap => ({
  [TemplateParentTypeEnum.EMAIL]: isV4
    ? emailV4.rawWidgets(t, additionalConfiguration)
    : email.rawWidgets(t, additionalConfiguration),
  [TemplateParentTypeEnum.POPUP]: isV4
    ? popupV4.rawWidgets(t, additionalConfiguration)
    : popup.rawWidgets(t, additionalConfiguration),
  [TemplateParentTypeEnum.EMBED]: isV4
    ? embedV4.rawWidgets(t, additionalConfiguration)
    : embed.rawWidgets(t, additionalConfiguration),
  [TemplateParentTypeEnum.FACEBOOKMESSENGER]: facebookMessenger.rawWidgets(t),
  [TemplateParentTypeEnum.TEASER]: teaser.rawWidgets(t, additionalConfiguration),
});

export const getColumnsWidgetLayouts = (): RawColumnsLayoutWidgetStructureMap => ({
  [TemplateParentTypeEnum.EMAIL]: email.rawLineWithColumns,
  [TemplateParentTypeEnum.POPUP]: popup.rawLineWithColumns,
  [TemplateParentTypeEnum.EMBED]: embed.rawLineWithColumns,
  [TemplateParentTypeEnum.TEASER]: teaser.rawLineWithColumns,
});
